import * as React from 'react';
import Svg, { SvgProps, G, Rect, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={27} height={38} {...props}>
      <G transform="rotate(180 13.439 19)" fill="#FFF" fillRule="evenodd">
        <Rect x={12.976} width={1.854} height={12.049} rx={0.927} />
        <Path d="M9.415 11.735c.698.635 2.193 2.068 4.486 4.301a315.265 315.265 0 014.167-4.096c5.141 1.887 8.81 6.825 8.81 12.621C26.878 31.983 20.861 38 13.439 38S0 31.983 0 24.561c0-6.02 3.959-11.116 9.415-12.826zm10.936 8.394h-1.41v7.398h-2.819v1.205h7.049v-1.205h-2.82v-7.398zm-12.145 0H6.712L4.23 28.732h1.59l1.615-6.543h.048l1.7 6.543h1.457l1.699-6.543h.048l1.615 6.543h1.59l-2.47-8.603h-1.506l-1.687 6.47h-.048l-1.675-6.47z" />
        <Path d="M21.255 5.231a.5.5 0 01-.006.707l-7.076 6.972a.5.5 0 01-.51.118.498.498 0 01-.272-.147L6.54 5.679a.5.5 0 01.005-.695l.27-.275.012-.012a.5.5 0 01.707.018l6.281 6.603 6.462-6.368.07-.057a.5.5 0 01.638.063z" />
      </G>
    </Svg>
  );
}

const AquireIconOn = React.memo(SvgComponent);
export default AquireIconOn;
